<template>
    <div>
        <b-spinner variant="primary" v-if="isLoading"></b-spinner>
        <vue-html2pdf
        v-else
        :show-layout="true"
        :float-layout="false"
        :enable-download="true"
        :preview-modal="true"
        :paginate-elements-by-height="1400"
        filename="Rapor"
        :pdf-quality="5"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="portrait"
        pdf-content-width="auto"
        ref="html2Pdf">
            <section slot="pdf-content">
                <div class="reportHeader">
                    <img src="../../../../assets/img/reportLogo.png" class="logo" alt="SanatTeknoloji" width="300" style="padding: 1rem">
                    <div class="info" style="width: 50%">
                        <ul>
                            <li> <strong> Sanat Teknoloji </strong></li>
                            <li> <strong> Adres: </strong> Atakent Mah., Atakan Cad., Öncü Sok. 9/A, 34760 Ümraniye/İstanbul </li>
                            <li> <strong> Telefon: </strong> 0850 259 00 99 </li>
                            <li> <strong> E-posta: </strong> destek@sanatteknoloji.com.tr </li>
                            <li> <strong> Web Sitesi: </strong> <a target="_blank" href="https://sanatteknoloji.com.tr/"> sanatteknoloji.com.tr </a> </li>
                        </ul>
                    </div>
                </div>
                <hr>
                <div class="report-details">
                    <div class="head">
                        <div class="title"> {{data.product.name}} #{{data.fault_support_no}}</div>
                        <div class="info">
                            <ul>
                                <li> <strong> Müşteri: </strong> {{data.customer.name}} </li>
                                <li> <strong> Seri Numarası: </strong> {{data.product_serial_number}} </li>
                                <li> <strong> Oluşturma Tarihi: </strong> {{moment(data.created_at)}} </li> 
                                <li > <strong> Garanti Bitiş Tarihi: </strong> {{moment(data.warranti_date)}} </li>
                                <li > <strong> Teslim Tarihi: </strong> {{moment(data.delivery_date)}} </li>
                                <li v-if="data.fault_support_result"> <strong> Sonuç: </strong> {{data.fault_support_result.name}} </li>
                            </ul>
                        </div>
                        <div> <strong> Problem: </strong> {{faultSupport.problem}} </div>
                        <div v-if="faultSupport.description"> <strong> Açıklama: </strong> {{faultSupport.description}} </div>
                    </div>
                    
                    <div class="movements">
                        <div class="title">Hareketler</div>
                        <b-table-simple hover responsive style="min-height: 0 !important;">
                            <b-th> Durum </b-th>
                            <b-th> Açıklama </b-th>
                            <b-th> Tarih </b-th>
                            <b-tbody>
                                <b-tr v-for="movement in faultSupport.movements" :key="movement.id"> 
                                    <b-td> {{movement.status.name}} </b-td>
                                    <b-td> {{movement.description}} </b-td>
                                    <b-td> {{moment(movement.created_at)}} </b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple> 
                    </div>
                </div>
            </section>
        </vue-html2pdf>
    </div> 
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
import moment from 'moment'

    export default {
        name: "FaultSupportReport",
        props: {
            data: Object,
            modalName: String,
            modalEvent: Function,
            save: Boolean,
            saveState: Function,
            formName: String
        },
        components: {
            VueHtml2pdf
        },
        computed: {
            isLoading() {
                return this.$store.getters.getStockLoading
            },
            faultSupport() {
                return this.$store.getters.faultSupport
            }
        },
        methods: {
            moment: function (date) {
                return moment(date.substring(0,19)).format('DD MMMM YYYY');
            },
        },
        watch: {
            data() {
                this.$store.dispatch('fetchFaultSupport', this.data.id)
            },
            save: async function(data){
                if(data){
                    this.$refs.html2Pdf.generatePdf()
                }
                this.saveState(false)
            },
        },
        mounted() {
            this.$store.dispatch('fetchFaultSupport', this.data.id)
        }
    }
</script>

<style lang="css" scoped > 
    @import "../styles/report.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/ERP/Stock/modals/Report.vue